import { CallBackProps, Step } from 'react-joyride'
import { useDispatch } from 'react-redux'
import { JoyRide } from 'builder/components/JoyRide'
import { useI18n } from 'builder/hooks/useI18n'
import { actions, selectors } from 'builder/modules/resumeEditor'
import { useTypedSelector } from 'builder/hooks/useTypedSelector'

const DEFAULT_STEP_DATA: Partial<Step> = {
  disableBeacon: true,
  placement: 'top',
  disableScrolling: false,
  spotlightClicks: true,
  disableOverlayClose: false,
  disableCloseOnEsc: false,
}

export const ElementHighlight = () => {
  const { i18n } = useI18n()
  const dispatch = useDispatch()
  const data = useTypedSelector(selectors.highlightedElementData)

  const autoTailoringFromPublicJobBoard = useTypedSelector(
    selectors.autoTailoringFromPublicJobBoard,
  )

  const onCallback = (callbackProps: CallBackProps) => {
    const { action, lifecycle } = callbackProps
    if (lifecycle !== 'complete') {
      return
    }
    if (['skip', 'close'].includes(action)) {
      dispatch(actions.closeHighlightedElement(callbackProps))
    }
    if (action === 'close') {
      data?.onClose?.()
    }
    if (action === 'skip') {
      data?.onSkip?.()
    }
  }

  if (autoTailoringFromPublicJobBoard.enabled) {
    return null
  }

  return data ? (
    <JoyRide
      run
      steps={[
        {
          ...DEFAULT_STEP_DATA,
          ...data,
        },
      ]}
      styles={{ options: { zIndex: 10000 } }}
      callback={onCallback}
      isStepsCountEnabled={false}
      finalButtonLabel={
        data.buttonLabel || i18n.t(`builder.resume_editor.element_highlight.default_button_text`)
      }
      showSkipOnLast={data.showSkipOnLast}
      skipButtonLabel={data.skipButtonLabel}
      nextButtonProps={data.nextButtonProps}
      skipButtonProps={data.skipButtonProps}
    />
  ) : null
}
